import theme from 'theme/theme';

export const INTERVAL_BY_HOUR = 'hour';

/**
 * Checks if interval is equal to hour.
 *
 * @param {string} interval
 *
 * @returns {boolean}
 */
export const isIntervalByHour = (interval) => {
    return interval === INTERVAL_BY_HOUR;
};

/**
 * @typedef ToolTipItem
 * @type {Object}
 * @property {string} label
 * @property {string} xLabel
 * @property {number} yLabel
 */

/**
 * Returns default x-axes label.
 *
 * @param {ToolTipItem[]} tooltipItems
 * @returns {string}
 */
const defaultTitleCallback = (tooltipItems) => {
    return tooltipItems[0].xLabel;
};

/**
 *  Returns default y-axes label.
 *
 * @param {ToolTipItem} tooltipItem
 * @returns {number}
 */
const defaultLabelCallback = (tooltipItem) => {
    return tooltipItem.yLabel;
};

export const useGraphConfig = (labelCallback = defaultLabelCallback, otherOptions = {}) => {
    return {
        elements: {
            line: {
                tension: 0, // Disables bezier curves
            },
        },
        scales: {
            xAxes: [
                {
                    time: {
                        unit: 'week',
                        displayFormats: {
                            'week': 'DD MMM',
                        },
                    },
                },
            ],
            yAxes: otherOptions.yAxes || [],
        },
        legend: {
            display: otherOptions.displayLegend || true,
            position: 'bottom',
            labels: {
                fontSize: 12,
            },
        },
        tooltips: {
            enabled: otherOptions.enableToolTips || true,
            mode: 'index',
            intersect: false,
            callbacks: {
                label: labelCallback,
                title: defaultTitleCallback,
            },
        },
        maintainAspectRatio: otherOptions.maintainAspectRatio || false,
        responsive: otherOptions.responsive || true,
    };
};

const graphColours = [
    theme.palette.primary1Color,
    theme.palette.secondary,
    theme.palette.darkOrange,
    theme.palette.irisBlue,
    theme.palette.envy,
    theme.palette.stardust,
    theme.palette.mossGreen,
    theme.palette.yukonGold,
];

/**
 * Generates dataset objects for graph from values, index, key and label.
 *
 * @param {Array} values
 * @param {number} index
 * @param {string} key
 * @param {string} label
 *
 * @returns {Object}
 */
export const generateDatasetObject = (values, index, key, label) => {
    return {
        backgroundColor: graphColours[index],
        borderCapStyle: 'butt',
        borderColor: graphColours[index],
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        data: values,
        fill: false,
        label: label || key,
        lineTension: 0.1,
        pointBackgroundColor: graphColours[index],
        pointBorderColor: graphColours[index],
        pointBorderWidth: 2,
        pointHitRadius: 10,
        pointHoverBackgroundColor: graphColours[index],
        pointHoverBorderColor: graphColours[index],
        pointHoverBorderWidth: 2,
        pointHoverRadius: 5,
        pointRadius: 1,
        key: key,
    };
};



// WEBPACK FOOTER //
// ./src/helpers/graph.js